module.exports = __webpack_public_path__ + "static/media/person-booth.edc23a65.svg";